var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "policy-item" },
    [
      _vm.news
        ? _c(
            "span",
            {
              staticClass: "common-positive-negative mr-8",
              class: ["is-" + _vm.data.sensitivity],
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.sentiment) + " " + _vm._s(_vm.thePercent)),
              ]),
            ]
          )
        : _c("span", { staticClass: "area" }, [
            _vm._v(_vm._s(_vm.data.province)),
          ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title", on: { click: _vm.clickHandle } }, [
          _c("span", { attrs: { title: _vm.data.title } }, [
            _vm._v(_vm._s(_vm.data.title)),
          ]),
          _vm.news
            ? _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.data.pubdate)),
              ])
            : _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.data.time)),
              ]),
        ]),
        _vm.news
          ? _c("div", { staticClass: "sub-title" }, [
              _vm._v("新闻来源：" + _vm._s(_vm.data.site)),
            ])
          : _c("div", { staticClass: "sub-title" }, [
              _vm._v(_vm._s(_vm.data.releaseOrganization)),
            ]),
        _vm.showTag && _vm.data.tags
          ? _c(
              "div",
              { staticClass: "tag-panel" },
              _vm._l(_vm.data.tags, function (item) {
                return _c("span", { key: item, staticClass: "policy-tag" }, [
                  _vm._v(_vm._s(item)),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm.news
        ? [
            _vm.dialogShow !== null
              ? _c("DialogNewsDetail", {
                  ref: "newsDetail",
                  attrs: { show: _vm.dialogShow, data: _vm.data },
                  on: {
                    "update:show": function ($event) {
                      _vm.dialogShow = $event
                    },
                  },
                })
              : _vm._e(),
          ]
        : [
            _vm.dialogShow !== null
              ? _c("DialogPolicyDetail", {
                  ref: "newsDetail",
                  attrs: { show: _vm.dialogShow, data: _vm.data },
                  on: {
                    "update:show": function ($event) {
                      _vm.dialogShow = $event
                    },
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }